import React, { useEffect, useState } from "react";

import ConfirmDialog from "../../../../components/actionDialogs/confirmDialog";
import CustomTable from "../../../../components/table/table";
import {
  get_project_proposal_list,
  admin_bussprop_delete,
} from "../../admin.api";
import Loader from "../../../../components/loader/loader";
import "./view.css";
import Snackbar from "../../../../components/snackbar/snackbar";
import jwtDecode from "jwt-decode";
import CSVExport from "../../../../components/csvExport";
import moment from "moment";
import * as XLSX from "xlsx";

export default function View(props) {
  const [data, setdata] = useState([]);
  const [view, setView] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);

  const [isActive, setIsActive] = useState(true);
  const [openAction, setOpenAction] = useState(false);
  const [activeData, setActiveData] = useState({});
  let adminType = Number(jwtDecode(props.state.payload).user_type);
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  const onSearch = () => {
    //
  };

  const handleProjectProposalList = () => {
    setIsActive(true);
    get_project_proposal_list(adminType).then((res) => {
      let tdata = res.data;
      tdata.forEach((item, index) => {
        item["slno"] = index + 1;
      });
      setdata(tdata);
      setIsActive(false);
    });
  };

  useEffect(() => {
    handleProjectProposalList();
  }, []);

  const handleView = (data) => {
    let path = `/project-proposal-view/${data.id}`;
    props.history.push(path);
  };
  async function fetchExportData() {
    const exportdata = [];
    data.forEach((item) => {
      exportdata.push({
        ["Proposal Title"]: item.project_proposal_title,
        Name: item.name,
        Email: item.email,
        ["Phone number"]: item.mobile,
        Date: item.created_at
          ? moment(item.created_at).format("DD-MMM-YYYY hh:mm A")
          : "--",
        Status:
          item.status == 0
            ? "Pending"
            : item.status == 1
            ? "Requested"
            : item.status == 5
            ? "Rejected"
            : item.status == 4
            ? "Approved"
            : "",
      });
    });
    return exportdata;
  }
  const handleEdit = () => {};
  const handleDeleteConfirm = (data) => {
    setOpenAction(false);
    setIsActive(true);
    admin_bussprop_delete(data.uuid)
      .then((res) => {
        setSnackMessage(res.message);
        setIsSnackError(false);
        setSnackOpen(true);
        setIsActive(false);
      })
      .catch((error) => {
        setSnackMessage(error.message);
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      });
  };
  const handleDelete = (data) => {
    setActiveData(data);
    setOpenAction(true);
  };
  const handleDownload = (item) => {
    let path = `${result}${item.file_upload_proposal}`;
    window.open(path, "_blank");
  };
  const handleCancelDelete = () => {
    setOpenAction(false);
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      handleProjectProposalList();
    }
  };
  const downloadExcel = async () => {
    const exportData = await fetchExportData();

    if (!exportData.length) {
      setSnackMessage("No data to export");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Project Proposals");

    const filename = "Project_Proposals.xlsx";
    XLSX.writeFile(workbook, filename);
  };
  return (
    <div>
      <Loader open={isActive} />
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <div className="view-container">
        {/* <h6>
          <b>Project Proposal</b>
        </h6> */}
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="m-0">
            <b>Project Proposal</b>
          </h6>
           <button
            className="btn btn-primary btn-sm"
            onClick={downloadExcel}
          >
            Download Excel
          </button>
        </div>
        <hr />
        {/* --------------admin----- */}
        {adminType === 1 && (
          <CustomTable
            {...props}
            columns={[
              { title: "Proposal Title", field: "project_proposal_title" },
              { title: "Name", field: "first_name" },
              { title: "Email", field: "email" },
              { title: "Phone number", field: "mobile" },
              { title: "Address", field: "address" },
              {
                title: "Proposal",
                field: "file_upload_proposal",
                type: "download",
              },
              {
                title: "Status",
                field: "status",
                type: "commonBusinessStatus",
              },
            ]}
            data={data}
            actions={[
              { type: "view", handleClick: handleView },

              // { type: "delete", handleClick: handleEdit },
            ]}
            handleDownload={handleDownload}
          />
        )}

        {/* -------------super-admin----- */}
        {adminType === 2 && (
          <CustomTable
            {...props}
            columns={[
              { title: "Proposal Title", field: "project_proposal_title" },
              { title: "Name", field: "first_name" },
              { title: "Email", field: "email" },
              { title: "Phone number", field: "mobile" },
              { title: "Address", field: "address" },
              {
                title: "Proposal",
                field: "file_upload_proposal",
                type: "download",
              },

              {
                title: "Status",
                field: "status",
                type: "commonBusinessStatus",
              },
            ]}
            data={data}
            actions={[
              { type: "view", handleClick: handleView },

              { type: "delete", handleClick: handleDelete },
            ]}
            handleDownload={handleDownload}
          />
        )}
      </div>
      {openAction && (
        <ConfirmDialog
          open={openAction}
          title="Delete Project Proposal ?"
          data={activeData}
          message="Are you sure to delete this Proposal?"
          secondary_action="Cancel"
          primary_action="Delete"
          handleClose={handleCancelDelete}
          handleConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
}
